import Quill from 'quill'
import DOMPurify from 'dompurify'

/**
 * Overrides quill's default clipboard module to sanitize pasted HTML
 * with DOMPurify before it is converted to a Quill delta.
 *
 * Compatible with quill v2 (convert receives { html, text }).
 */
const Clipboard = Quill.import('modules/clipboard')

class SafeClipboard extends Clipboard {
  convert({ html, text } = {}) {
    if (typeof html === 'string') {
      html = DOMPurify.sanitize(html)
    }
    return super.convert({ html, text })
  }
}

Quill.register('modules/clipboard', SafeClipboard, true)
